import {api} from './Api';

export const getDatabases = () => {
  return api.get('/database/?action=tree').then(res => res.data);
}

export const getSchemas = (databaseId: string | number) => {
  return api.get(`/database/${databaseId}/schemas/?action=tree`).then(res => res.data);
};

export const getTables = (databaseId: number, schema_name: string) => {
  return api.get(`/database/${databaseId}/schema/${schema_name}/?action=tree`).then(res => res.data);
};

export const getColumns = (databaseId: number, tableName: string, schemaName: string) => {
  return api.get(`/database/${databaseId}/table/${tableName}/${schemaName}/?action=tree`).then(res => res.data);
};

export const selectStar = (database: string, schema: string, table: string) => {
  return api.get(`database/${database}/select_star/${table}/${schema}/`).then(res => res?.data);
}
